import React from "react";

import { useNavbarContext } from '../Navbar';
import styles from './NavBrand.module.scss';

export const NavBrand = () => {
  const { logoPath } = useNavbarContext();

  return (
    <div className={styles['nb-root']}>
      <a href="/" className={styles.img}>
        <img
          src={logoPath}
          alt="lifepal-user-logo"
          width="93"
          height="32"
        />
      </a>
    </div>
  );
}